import React from 'react';
import MainNavbar from '../components/presentation/MainNavbar';
import NotFoundBody from '../components/presentation/NotFoundBody';

class About extends React.Component {
  render() {
    document.title = 'ReTrue.Org | Page Not Found';

    return (
      <div className="index">
        <MainNavbar />
        <NotFoundBody />
      </div>
    );
  }
}

About.defaultProps = {
  title: 'Page Not Found',
  description: 'ReTrue.Org | Page Not Found',
};

export default About;
